import { render } from "./GalleryNotes.vue?vue&type=template&id=2d174410&scoped=true"
import script from "./GalleryNotes.vue?vue&type=script&lang=js"
export * from "./GalleryNotes.vue?vue&type=script&lang=js"

import "./GalleryNotes.vue?vue&type=style&index=0&id=2d174410&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d174410"]])

export default __exports__